const axios = require("axios");
const querystring = require("querystring");
const { Notification } = require("nice-design");

const TOWORDS_TOKEN = localStorage.token;
const token = () => {
  if (TOWORDS_TOKEN) return TOWORDS_TOKEN;
  return localStorage.getItem("token");
};

function createHttp({ type, baseURL, token }) {
  const Http = axios.create({
    baseURL: baseURL ? baseURL : "", //api host：api的请求基础地质
    timeout: 1000 * 60 * 5, // 超时时间ms
    withCredentials: false,
    headers: {
      common: {
        Authorization: token,
      } /* ,
            post:{
                'Content-Type':'application/x-www-form-urlencoded'
            } */,
    },
  });
  return function ({ url, params, is_qs }) {
    let data = params || {};
    if (is_qs) {
      data = querystring.stringify(data);
    }
    let config = {
      url,
      data,
      method: type,
    };
    return new Promise((resolve, reject) => {
      Http(config)
        .then((res) => {
          resolve(res);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };
}

async function postCtrl(opt) {
  let config = Object.assign(
    {
      url: "",
      params: {},
      is_qs: false,
    },
    opt
  );
  const _post = createHttp({
    type: "post",
    baseURL: config.baseURL ? config.baseURL : "",
    token: config.token,
  });
  const data = await _post(config).catch((err) => {
    return err;
  });
  if (data.status === 200) {
    return data.data;
  } else {
    return {
      status: data.response.status,
      ...data.response.data,
    };
  }
}

async function getCtrl(opt) {
  let config = Object.assign(
    {
      url: "",
      params: {},
      is_qs: false,
    },
    opt
  );
  const _get = createHttp({
    type: "get",
    baseURL: config.baseURL ? config.baseURL : "",
  });
  const data = await _get(config).catch((err) => {
    return err;
  });
  if (data.status === 200) {
    return data.data;
  } else {
    return {
      status: data.response.status,
      data: data.response.data,
    };
  }
}
const $postApi = async (url, params = {}) => {
  const is_qs = true;
  const res = await postCtrl({
    url,
    params,
    is_qs,
    baseURL: "https://api.towords.net",
  });
  return res;
};
const $post = async (url, params) => {
  const res = await postCtrl({
    url,
    params,
    token: `Bearer ${token()}`,
  });
  if (res.status === 401) {
    window.location.href = `/login?refer=${encodeURIComponent(
      window.location.href
    )}`;
  } else {
    return res;
  }
};
export const _post = createHttp("post");
export const $postNode = async (url, params) => {
  let config = {
    url,
    params,
    is_qs: false,
  };
  const data = await _post(config).catch((err) => {
    return err;
  });
  switch (data.code) {
    case 401:
      window.location.href = `/login?refer=${encodeURIComponent(
        window.location.href
      )}`;
      break;
    case 200:
      return data.data;
    default:
      return {
        status: data.response.status,
        data: data.response.data,
      };
  }
};

export const $postBody = async (url, params) => {
  let config = {
    url,
    params,
    is_qs: false,
    baseURL: "https://api.towords.net",
  };
  const _post = createHttp({
    type: "post",
    baseURL: config.baseURL ? config.baseURL : "",
    token: config.token,
  });
  const data = await _post(config).catch((err) => {
    return err;
  });
  if (data.status == 200) {
    return data.data;
  } else {
    return {
      status: data.response.status,
      data: data.response.data,
    };
  }
};

const $get = async (url, params) => {
  const data = await axios({
    method: "get",
    url: `https://api.towords.net${url}`,
    params: params,
  });
  if (data.status == 200) {
    return data.data;
  } else {
    return {
      status: data.response.status,
      data: data.response.data,
    };
  }
};

export { $post, $postApi, $get };
